export const GET_ADMIN_STATS = "get/admin/stats";
export const GET_CART_PERCENTAGE = "get/admin/cart_percentage";
export const GET_CHECKOUT_PERCENTAGE = "get/admin/checkout_percentage";
export const GET_TOTAL_REVENUE = "get/admin/total_revenue";
export const GET_CONVERSION_RATE = "get/admin/conversion_rate";
export const ADMIN_STATS_LOADING = "stats/admin/loading";
